


























































































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Modal from "@/components/shared/modal/Modal.vue";
import { ShipmentService } from "@/services/ShipmentService";
import { CourierDTO, PaperlessDocumentDto } from "@/model/data.model";
import i18n from "@/lang/i18n";
import { alertDangerReason } from "@/services/Helpers";
import { Validations } from "vuelidate-property-decorators";
import { required } from "vuelidate/lib/validators";
@Component({
  components: {
    MbeModal: Modal
  }
})
export default class AddPaperlessDocumentModalComponent extends Vue {
  @Prop({ default: undefined })
  courierId?: number;
  @Prop({ default: false })
  isFromShipment: boolean;
  courierDocTypeId = "";
  documentTypeId = "";
  disableConfirmUploadButton = true;
  docUploadParams: any = null;
  paperlessAttachment: any = null;
  paperlessAttachmentFilename = "";
  showErrorWrongFileType = false;
  documentTypes: any[] = [];
  couriers: CourierDTO[] = [];
  notes = "";
  @Validations()
  validations() {
    return {
      documentTypeId: { required },
      notes: { maxLength: 255 }
    };
  }
  mounted() {
    this.fetchDocTypes();
  }
  closePaperlessModal() {
    this.documentTypeId = "";
    this.paperlessAttachment = null;
    this.paperlessAttachmentFilename = "";
    this.$emit("closeModal");
  }

  checkDisableConfirmUploadButton() {
    this.disableConfirmUploadButton = true;

    this.docUploadParams = {
      docTypeId: this.documentTypeId
    };

    const mimeTypeAccepted: Array<string> = ["application/pdf"];
    const extensionsAccepted: Array<string> = ["pdf"];
    const reExt: any = /(?:\.([^.]+))?$/;

    if (
      this.paperlessAttachment != null &&
      this.paperlessAttachment.name != null
    ) {
      const ext = reExt?.exec(this.paperlessAttachment.name)[1];
      this.showErrorWrongFileType = !(
        mimeTypeAccepted.includes(this.paperlessAttachment.type) &&
        extensionsAccepted.includes(ext.toLowerCase())
      );
    }

    if (!(this.docUploadParams == null || this.paperlessAttachment == null)) {
      if (this.docUploadParams.docTypeId !== "" && !this.showErrorWrongFileType)
        this.disableConfirmUploadButton = false;
    }
  }

  uploadPaperless() {
    this.importPaperless(this.paperlessAttachment);
  }

  async importPaperless(file?: any) {
    const formData: any = new FormData();

    if (file) {
      formData.append("paperlessDocuments[0].file", file);
    }
    formData.append(
      "paperlessDocuments[0].paperlessMbeDocumentTypeId",
      this.docUploadParams.docTypeId
    );
    formData.append(
      "customerId",
      this.$store.getters["customer/info"].customerId
    );
    formData.append("molUsername", this.$store.getters.user.username);
    formData.append("fromMol", true);
    formData.append("paperlessDocuments[0].notes", this.notes);

    await ShipmentService.prototype
      .uploadPaperlessDocument(formData)
      .then((res: PaperlessDocumentDto[]) => {
        this.$notify.success(String(i18n.t("document_added_successfully")));
        //Refresh search results if they were displayed
        this.$emit("searchDocuments", res[0].id);
        this.paperlessAttachmentFilename = "";
        this.paperlessAttachment = null;
      })
      .catch(err => {
        return alertDangerReason(err, this);
      });
    this.closePaperlessModal();
  }

  fetchDocTypes() {
    ShipmentService.prototype
      .getAvailablePaperlessDocumentTypes()
      .then((res: any) => {
        if (this.courierId) {
          this.documentTypes = res.filter((item: any) => {
            return Object.keys(item.allowedCouriers).includes(
              this.courierId.toString()
            );
          });
        } else {
          this.documentTypes = res;
        }
      });
  }

  processFiles($event: any) {
    const files = $event.target.files;
    this.paperlessAttachmentFilename = files[0].name;
    this.paperlessAttachment = files[0];

    this.checkDisableConfirmUploadButton();
  }
}
